export interface JwtPayloadMinimal {
  sub?: string;
  exp?: number;
  iat?: number;
}

function decodeBase64Url(segment: string): string {
  const normalized = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(
    normalized.length + ((4 - (normalized.length % 4)) % 4),
    "=",
  );
  return atob(padded);
}

/**
 * Decodifica el payload de un JWT sin verificar firma (solo para scheduling de refresh en cliente).
 */
export function decodeJwtPayload(token: string): JwtPayloadMinimal | null {
  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const json = decodeBase64Url(parts[1]);
    const parsed: unknown = JSON.parse(json);
    if (!parsed || typeof parsed !== "object") return null;
    const record = parsed as Record<string, unknown>;
    return {
      sub: typeof record.sub === "string" ? record.sub : undefined,
      exp: typeof record.exp === "number" ? record.exp : undefined,
      iat: typeof record.iat === "number" ? record.iat : undefined,
    };
  } catch {
    return null;
  }
}

/** Milisegundos hasta expiración menos skew (default 2 min antes). null si no decodificable. */
export function getMsUntilExpiry(
  token: string,
  skewMs = 120_000,
): number | null {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return null;
  const expiresAtMs = payload.exp * 1000;
  return expiresAtMs - Date.now() - skewMs;
}

/** true si el token expira en menos de thresholdMs (default 5 min). */
export function isJwtExpiringSoon(
  token: string,
  thresholdMs = 5 * 60 * 1000,
): boolean {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return false;
  return payload.exp * 1000 - Date.now() < thresholdMs;
}
